import { fetchAndyAgentsReplyMock, fetchAndyAgentsWidgetNextMock } from '@/components/domain/andy-agents/andyAgentsReplyMock.js'

const state = {}

const actions = {
    fetchReply(context, message) {
        // Pendiente de API: sustituir esta llamada por api de src/core/api.js,
        // devolver { text, widgets } y eliminar andyAgentsReplyMock.js.
        return fetchAndyAgentsReplyMock(message)
    },
    fetchWidgetNext(context, payload) {
        // Pendiente de API: sustituir por api de src/core/api.js con offset o nextCursor.
        return fetchAndyAgentsWidgetNextMock(payload)
    }
}

export default {
    namespaced: true,
    state,
    actions
}
